import React, { useEffect } from 'react';
import TextBreadcrumb from './TextBreadcrumb';
import UndoRedo from './UndoRedo';
import ScreenToggle from './ScreenToggle';
import ZoomButton from './ZoomButton';
import Actions from './Actions';
import SaveAndPublish from './SaveAndPublish';
import { BackIcon } from '../../../../assets/Icons';
import { getMaterial } from '../../../../../redux/materialSlice';
import { useSelector } from 'react-redux';
import { allSteps, getMainConfig } from '../../../../../redux/stepsSlice';
import { API_ENDPOINTS } from '../../../utils/endpoints';
import { http_put } from '../../../utils/api_client';

function Toolbar({ companySlug, lmSlug, previewDevice, onPreviewDeviceChange }) {
  const steps = useSelector((state) => allSteps(state));
  const config = useSelector((state) => getMainConfig(state));
  const material = useSelector((state) => getMaterial(state));

  const handleSave = () => {
    if (lmSlug === null) return;
    http_put(API_ENDPOINTS.PUT_PATH(lmSlug), { data: steps, config })
      .then(() => {
        setTimeout(() => {}, 2000);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleSave();
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [steps, config]);

  const goBack = () => {
    if (companySlug) window.location.href = `/${companySlug}/paths`;
  };

  return (
    <div className="path-authoring-toolbar un-toolbar un-pe-topbar">
      <div className="un-pe-topbar__left">
        <button type="button" className="un-pe-back" onClick={goBack} aria-label="Back to paths">
          <BackIcon />
        </button>
        <TextBreadcrumb parentTitle="Paths" subTitle={material?.name} companySlug={companySlug} />
        <span className="un-pe-saved">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#1E9E63" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
          Saved
        </span>
      </div>
      <div className="un-pe-topbar__center">
        <UndoRedo />
        <div className="un-pe-tdiv" />
        <ScreenToggle value={previewDevice} onChange={onPreviewDeviceChange} />
        <ZoomButton />
      </div>
      <div className="un-pe-topbar__right">
        {lmSlug && (
          <a className="un-pe-responses" href={`/${companySlug}/paths/responses?path=${lmSlug}`} title="View responses for this path">
            <svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M4 16V9M10 16V4M16 16v-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
            Responses
          </a>
        )}
        <Actions />
        <SaveAndPublish companySlug={companySlug} />
      </div>
    </div>
  );
}

export default Toolbar;
